import React from 'react';
import HeroCarousel from '../components/sections/HeroCarousel';
import CoursesSection from '../components/sections/CoursesSection';

const Home: React.FC = () => {
  return (
    <div>
      <HeroCarousel />
      <CoursesSection />
    </div>
  );
};

export default Home;